module.exports = __webpack_public_path__ + "static/media/Used Cat Backhoe Loaders - Toromont Cat.ff36ac9b.jpg";